{
  "General_InitContext_Undefined": "Kein Context für die Bestellung gefunden. Suchen Sie ein Produkt auf der Webseite und klicken Sie dort auf Bestellen",
  "General_Api_Failed": "Fehler beim abrufen von Daten via API. Bitte laden Sie die Seite neu und versuchen Sie es erneut.",
  "General_MoreDetails": "Mehr erfahren",
  "General_LessDetails": "Weniger Details",
  "General_Page_Back": "Zurück",
  "General_Page_Next": "Weiter",

  "Cart_Title": "Ihre Bestellung",
  "Cart_Header_NonRecurring": "Einmalig",
  "Cart_Header_NonRecurring_Short": "Einm.",
  "Cart_Header_Monthly": "Monatlich",
  "Cart_Header_Monthly_Short": "Mtl.",
  "Cart_Subtotal": "Zwischentotal",
  "Cart_Total": "Total CHF",
  "Cart_Prices_Incl_Vat": "Alle Preise in CHF, inkl. MWST",
  "Cart_Prices_Excl_Vat": "Alle Preise in CHF, exkl. MWST",
  "Cart_Partner_Number": "Partner-ID: {partnerNumber}",
  "Cart_Mindestvertragsdauer_12Mt": "Die Mindestvertragsdauer beträgt 12 Monate ab dem ersten Tag der Abo-Verrechnung.",

  "ConfigsNavigation_Access" : "Internet Installation",
  "ConfigsNavigation_Phone" : "Telefonie Installation",
  "ConfigsNavigation_Tv" : "TV Installation",
  "ConfigsNavigation_Mobile" : "Mobile Installation",
  "ConfigsNavigation_NoConfigs": "Keine Konfiguration",

  "Configs_No_Configs": "Nichts zu konfigurieren",
  "ConfigsAccess_Title": "Ihren Internetanschluss aktivieren",
  "ConfigsAccess_Wishdate_Title": "Wann möchten Sie Ihren Internetanschluss zu Hause nutzen?",
  "ConfigsAccess_Wishdate_Asap": "Schnellstmöglich (5-10 Arbeitstage)",
  "ConfigsAccess_Wishdate_Wishdate": "Wunschdatum",

  "ConfigsTv_Wishdate_Title": "Wann möchten Sie Ihr TV-Angebot nutzen?",
  "ConfigsTv_Wishdate_Asap": "So schnell wie möglich",
  "ConfigsTv_Wishdate_Wishdate": "Wunschdatum",

  "ConfigsAccess_FixIp_Title": "RIPE-Registrierung für fixe IP-Adressen",
  "ConfigsAccess_FixIp_Subtitle": "Ab einem IP-Subnetz von 4 oder mehr IP-Adressen ist eine Registrierung bei der Vergabestelle RIPE erforderlich. Bitte geben Sie uns nachfolgende Angaben bekannt:",
  "ConfigsAccess_FixIp_HandleLabel": "RIPE-Handle (wenn bereits vorhanden)",
  "ConfigsAccess_FixIp_ReasonLabel": "Firma, Zweck",
  "ConfigsAccess_FixIp_ReasonInfo": "Bitte beschreiben Sie die Tätigkeit Ihrer Firma und für welchen Zweck Sie die IP-Adressen benötigen.",
  "ConfigsAccess_FixIp_OneRequired": "Bitte geben Sie entweder einen RIPE-Handle oder eine Begründung (Firma, Zweck) an.",

  "ConfigsAccess_OtoId_Title": "Wie lautet die Nummer Ihrer Glasfasersteckdose (OTO-ID)?",
  "ConfigsAccess_OtoId_Info": "Die Glasfasersteckdose befindet sich in der Regel im Multimedia-Verteilkasten oder neben der bestehenden Telefon-/TV-Dose in  Ihrem Wohnzimmer. Jede Glasfasersteckdose hat eine Nummer, die  sogenannte OTO-ID. Diese beginnt mit A.XXX oder B.XXX. Bitte geben Sie  diese bei der Bestellung an.",
  "ConfigsAccess_OtoId_NotAvailable": "Noch keine Glasfasersteckdose vorhanden",
  "ConfigsAccess_OtoId_NotAvailable_Info": "Die Aktivierungszeit ist unbestimmt. In der Regel kann die Glasfaserdose innerhalb von 4 bis 6 Wochen installiert werden.",
  "ConfigsAccess_OtoId_CheckerList": "Aus Liste wählen",
  "ConfigsAccess_OtoId_OwnEntry": "OTO-ID-Nummer eingeben",
  "ConfigsAccess_OtoId_OwnEntry_Placeholder": "Wenn Sie eine Glasfasersteckdose haben, geben Sie bitte die ID auf der Dose ein.",
  "ConfigsAccess_OtoId_PleaseSelect": "OTO-ID-Nummer auswählen",

  "ConfigsAccess_PreviousTenant_Title": "Übernehmen Sie den Anschluss eines Vormieters?",
  "ConfigsAccess_PreviousTenant_Info": "Bitte geben Sie an, ob es sich um einen neuen Anschluss handelt oder ob Sie den Anschluss eines Vormieters bzw. eines anderen Anbieters übernehmen.",
  "ConfigsAccess_PreviousTenant_DslNew": "Bestehende Leitungsnummer / Name Vormieter unbekannt",
  "ConfigsAccess_PreviousTenant_DslNew_Info": " Auftrag an Elektrikerin / Elektriker auf eigene Kosten notwendig",
  "ConfigsAccess_PreviousTenant_DslProviderChange": "Anbieterwechsel / Übernahme eines bestehenden Anschlusses",
  "ConfigsAccess_PreviousTenant_DslNumber_Label": "Leitungsnummer oder Name des Vormieters",
  "ConfigsAccess_PreviousTenant_DslNumber_Info": "Bitte geben Sie entweder die Leitungsnummer (NSN-Nummer) oder den Namen/Vornamen und/oder die Telefonnummer der Vormieterin/des Vormieters an",

  "ConfigsPhone_AdditionalNumbers_Title": "Einzelne Rufnummern",
  "ConfigsPhone_AdditionalNumbers_Question": "Wie viele Festnetz-Nummern möchten Sie?",
  "ConfigsPhone_AdditionalNumbers_Monthly": "monatlich",
  "ConfigsPhone_AdditionalNumbers_Included": "inklusive",
  "ConfigsPhone_AdditionalNumbers_NonRecurring": "einmalig",

  "ConfigsPhone_NewOrPorting_Title": "Neue oder portierte Rufnummern",
  "ConfigsPhone_NewOrPorting_New_Label": "Neu",
  "ConfigsPhone_NewOrPorting_Ported_Label": "Portiert",
  "ConfigsPhone_NewOrPorting_New_Question": "Neue Rufnummern",
  "ConfigsPhone_NewOrPorting_Ported_Question": "Portierte/übernommene Rufnummern",
  "ConfigsPhone_NewOrPorting_Monthly": "monatlich",
  "ConfigsPhone_NewOrPorting_NonRecurring": "einmalig",

  "ConfigsPhone_LandlineNew_Title": "Neue Rufnummer",
  "ConfigsPhone_LandlineNew_Label": "Wunschvorwahl für neue Rufnummer",
  "ConfigsPhone_LandlineNew_WishdateType_Asap": "So schnell wie möglich",
  "ConfigsPhone_LandlineNew_WishdateType_Wishdate": "Wunschdatum",

  "ConfigsPhone_LandlinePorting_Title": "Rufnummer portieren/übernehmen",
  "ConfigsPhone_LandlinePorting_WishdateType_Wishdate": "Wunschdatum",
  "ConfigsPhone_LandlinePorting_WishdateType_Wishdate_Info": "Ich möchte meine Nummer vor Ablauf der Mindestvertragsdauer übertragen und erkläre mich hiermit bereit, dem bisherigen Anbieter alle in diesem Zusammenhang allenfalls geschuldeten Zahlungen zu leisten.",
  "ConfigsPhone_LandlinePorting_WishdateType_ContractExpiry": "Datum des Vertragsablaufs",
  "ConfigsPhone_LandlinePorting_WishdateType_ContractExpiry_Info": "Ich möchte die Vertragsdauer bei meinem bisherigen Anbieter einhalten (Sie dürfen die Anfrage höchstens 365 Tage vor Vertragsablauf stellen).",
  "ConfigsPhone_LandlinePorting_Wishdate_Placeholder": "Datum wählen",

  "ConfigsMobile_Number_Title": "Wie möchten Sie Ihre Mobilnummer erhalten?",
  "ConfigsMobile_Number_New": "Neue Mobilnummer",
  "ConfigsMobile_Number_Porting": "Bestehende Nummer portieren",

  "ConfigsMobile_Sim_Title": "Sim-Karte",
  "ConfigsMobile_Sim_Monthly": "monatlich",
  "ConfigsMobile_Sim_NonRecurring": "einmalig",

  "ConfigsMobile_MultiSim_Title": "Multi-Sim",
  "ConfigsMobile_MultiSim_None": "Keine Multi-Sim",
  "ConfigsMobile_MultiSim_Multi": "Multi-Sim (Standard- und eSim)",
  "ConfigsMobile_MultiSim_Monthly": "monatlich",
  "ConfigsMobile_MultiSim_NonRecurring": "einmalig",

  "ConfigsMobile_New_Title": "Wann möchten Sie Ihre neue Mobilnummer nutzen?",
  "ConfigsMobile_New_WishdateType_Asap": "So schnell wie möglich",
  "ConfigsMobile_New_WishdateType_Wishdate": "Wunschdatum",

  "ConfigsMobile_Porting_Title": "Mobilnummer portieren/übernehmen",
  "ConfigsMobile_Porting_MobileNumber_Label": "Mobilnummer",
  "ConfigsMobile_Porting_Type_NotComply": "Wunschdatum",
  "ConfigsMobile_Porting_Type_NotComply_Info": "Ich möchte meine Nummer vor Ablauf der Mindestvertragsdauer übertragen und erkläre mich hiermit bereit, dem bisherigen Anbieter alle in diesem Zusammenhang allenfalls geschuldeten Zahlungen zu leisten.",
  "ConfigsMobile_Porting_Type_Comply": "Datum des Vertragsablaufs",
  "ConfigsMobile_Porting_Type_Comply_Info": "Ich möchte die Vertragsdauer bei meinem bisherigen Anbieter einhalten (Sie dürfen die Anfrage höchstens 365 Tage vor Vertragsablauf stellen).",
  "ConfigsMobile_Porting_Date_Placeholder": "Datum wählen",
  "ConfigsMobile_Porting_Time_Label": "Uhrzeit der Portierung",
  "ConfigsMobile_Porting_PreviousProvider_Label": "Bisheriger Anbieter",
  "ConfigsMobile_Porting_PreviousSubscriptionType_Label": "Bisheriges Abo-Modell",



  "CustomerData_Address_Invoice_Title": "Rechnungsadresse",
  "CustomerData_Address_Delivery_Title": "Lieferadresse",
  "CustomerData_Address_Technical_Title": "Adresse für technischen Kontakt",
  "CustomerData_Address_SameAsInvoice": "Gleich wie Rechnungsadresse",
  "CustomerData_ShowDeliveryAddress": "Abweichende Lieferadresse",
  "CustomerData_ShowTechnicalAddress": "Abweichende Adresse für technischen Kontakt",
  "CustomerData_BillingType_Title": "Rechnungszustellung",
  "CustomerData_BillingType_Email_Label": "Rechnung per E-Mail oder als eBill",
  "CustomerData_BillingType_Email_Info": "(eBill erfordert Anmeldung über E-Banking)",
  "CustomerData_BillingType_Post_Label": "Papierrechnung auf dem Postweg",
  "CustomerData_BillingType_Post_Info": "(CHF {amount}/Rechnung)",
  "CustomerData_BillingPeriod_Title": "Zahlungsperiode",
  "CustomerData_BillingPeriod_MIV_Label": "Monatlich",
  "CustomerData_BillingPeriod_JIV_Label": "Jährlich",
  "CustomerData_BillingPeriod_HIV_Label": "Halbjährlich",
  "CustomerData_BillingPeriod_QIV": "Vierteljährlich",
  "CustomerData_Address_ContactType_Private": "Privatperson",
  "CustomerData_Address_ContactType_Company": "Firma",
  "CustomerData_Address_CompanyName_Label": "Firmenname",
  "CustomerData_Address_Uid_Label": "UID",
  "CustomerData_Address_Gender_Label": "Anrede",
  "CustomerData_Address_Gender_Male": "Herr",
  "CustomerData_Address_Gender_Female": "Frau",
  "CustomerData_Address_Gender_Other": "Keine Angabe",
  "CustomerData_Address_FirstName_Label": "Vorname",
  "CustomerData_Address_LastName_Label": "Nachname",
  "CustomerData_Address_Birthdate_Label": "Geburtsdatum",
  "CustomerData_Address_Street_Label": "Strasse",
  "CustomerData_Address_BuildingNumber_Label": "Hausnummer",
  "CustomerData_Address_Zip_Label": "PLZ",
  "CustomerData_Address_City_Label": "Ort",
  "CustomerData_Address_CountryCode_Label": "Land",
  "CustomerData_Address_Email_Label": "E-Mail",
  "CustomerData_Address_Phone_Label": "Telefon",
  "CustomerData_Address_Mobile_Label": "Mobile",
  "CustomerData_Address_Save": "Speichern",
 
  "LanguageSwitch_CurrentLanguage": "Deutsch",

  "MainProducts_AccessInstallationAddress":"Installationsadresse",
  "MainProducts_AccessInstallationAddress_Change":"ändern",
  "MainProducts_Title": "Stellen Sie Ihr eigenes Paket zusammen",
  "MainProducts_Required_Combinations": "Welche Produkte möchten Sie kombinieren?",
  "MainProducts_ShowMoreBandwidth":"Für weitere Geschwindigkeiten geben Sie bitte Ihre Adresse an.",
  "MainProducts_ShowChecker":"Weitere Angebote finden",
  "MainProducts_Save_Order_Not_Available":"Die Bestellung ist nicht verfügbar. Suchen Sie auf der Webseite nach einem Produkt oder verwenden Sie den Verfügbarkeitschecker.",

  "Navigation_Products_Title": "Produkte",
  "Navigation_Options_Title": "Optionen",
  "Navigation_Installation_Title": "Installation",
  "Navigation_Information_Title": "Angaben",
  "Navigation_Completion_Title": "Abschluss",
  "Completion_ConfigValues_Title": "Produktkonfiguration",
  "Completion_Terms_Title": "Abo-Bestimmungen",
  "Completion_Terms_Required": "Bitte akzeptieren Sie die Abo-Bestimmungen, um die Bestellung abzuschliessen.",
  "Completion_Submit": "Verbindlich bestellen",

  "Completion_VoucherCode_Title": "Gutscheincode",
  "Completion_VoucherCode_Label": "Gutscheincode",
  "Completion_VoucherCode_Save": "Einlösen",

  "Completion_ReferrerCode_Title": "Empfehlungscode",
  "Completion_ReferrerCode_Label": "Empfehlungscode",
  "Completion_ReferrerCode_Save": "Einlösen",

  "OrderSource_Title": "Wie sind Sie auf uns aufmerksam geworden?",
  "OrderSource_Label": "Quelle",

  "Price_Nonrecurring": "Einmalig",
  "Price_Monthly": "Monatlich",
  "Products_Total_CHF": "Total CHF",
  "Products_OrderButton_Label": "Bestellen",
  "Products_Bestseller_Title": "Bestseller",
  "Product_Options_Page_Title": "Optionen",
  "Products_Details_Link_Text": "Details & Abo-Vergleich",


  "OptionsNavigation_NoOptions": "Keine Optionen",
  "OptionsNavigation_Access": "Internet Optionen",
  "OptionsNavigation_Skip": "Überspringen",
  "OptionsNavigation_Phone": "Telefonie Optionen",
  "OptionsNavigation_Tv": "TV Optionen",

  "OptionsBlockRow_Kostenlos": "Kostenlos",
  "OptionsBlockRow_Kostenlos_Leihweise": "Kostenlos Leihweise",

  "Options_No_Options": "Keine Optionen",
  "Options_Access_Router_Title": "Hardware für Ihren Internet-Anschluss",
  "Options_Access_Router_Subtitle": "Welche Hardware möchten Sie nutzen?",
  "Options_Access_Router_ShowMore_Title": "Weitere Router",
  "Options_Access_Router_ShowLess_Title": "Weniger Router",
  "Options_Access_Accessories_Title": "Zubehör für Ihren Internet-Anschluss",
  "Options_Access_Accessories_Subtitle": "Welches Zubehör möchten Sie nutzen?",
  "Options_Access_Accessories_ShowMore_Title": "Weiteres Zubehör",
  "Options_Access_Accessories_ShowLess_Title": "Weniger Zubehör",
  "Options_Access_Installation_Title": "Brauchen Sie Unterstützung bei der Inbetriebnahme des Routers:",
  "Options_Access_Installation_Wanted_No": "**Nein**, ich installiere selbst.",
  "Options_Access_Installation_Wanted_Yes": "**Ja**",

  "Options_FixIp_Title": "Erweiterte Optionen - Zusätzliche Fixe IP-Adressen",
  "Options_FixIp_SubTitle": "Nur relevant für spezielle Heimserver, Fernzugriffe oder Anwendungen Ihres IT-Dienstleisters.",
  "Options_FixIp_Not_Selected": "Zusätzliche Fixe IP-Adressen",
  "Options_FixIp_NonRecurring": "Einmalig",
  "Options_FixIp_Monthly": "Monatlich",

  "Options_Phone_Hardware_Title": "Passendes Telefonie-Zubehör",
  "Options_Phone_Hardware_ShowMore_Title": "Weitere Telefone",
  "Options_Phone_Hardware_ShowLess_Title": "Weniger Telefone",

  "Options_Tv_Title":"TV-Optionen für Ihr Abonnement",

  "Options_TvChannelPack_ChannelsWanted": "Möchten Sie Sprachpakete oder ein Family Paket hinzufügen?",
  "Options_TvChannelPack_ChannelsWanted_No": "**Nein**, ich nutze das Basisangebot.",
  "Options_TvChannelPack_ChannelsWanted_Yes": "**Ja**, Pakete hinzufügen.",
  "Options_TvChannelPack_ChannelsWanted_Yes_Info": "Ergänzen Sie Ihr Basisangebot mit weiteren Sendern.",
  "Options_TvChannelPack_ShowMore_Title": "Weitere Senderpackete",
  "Options_TvChannelPack_ShowLess_Title": "Weniger Senderpackete",
  "Options_TvChannelPack_Senderlist": "Senderliste",
  
  "Options_TvBox_Title": "TV-Boxen",
  "Options_TvBox_ShowMore_Title": "Weitere TV-Boxen",
  "Options_TvBox_ShowLess_Title": "Weniger TV-Boxen",
  "Options_TvBox_Boxes_Wanted":"Möchten Sie zusätzliche TV-Boxen nutzen?",
  "Options_TvBox_Boxes_Wanted_No":"**Nein**, ich nutze nur die im Abo enthaltene TV-Box",
  "Options_TvBox_Boxes_Wanted_Yes":"**Ja**, ich möchte weitere TV-Boxen nutzen",
  "Options_TvBox_Boxes_Wanted_Yes_Info":"Grund, wann zusätzliche TV-Boxen nötig sind (Vorteil)",
  "Options_TvBox_Boxes_Monthly":"monatlich",
  "Options_TvBox_Boxes_NonRecurring":"einmalig",

  "SwissLandlineNumberEntry_Invalid": "Bitte geben Sie eine gültige Schweizer Telefonnummer ein.",
  "SwissLandlineNumberEntry_NoMobile": "Mobilnummern sind nicht zulässig. Bitte geben Sie eine Festnetznummer ein.",
  "SwissMobileNumberEntry_Invalid": "Bitte geben Sie eine gültige Schweizer Mobilnummer ein.",

  "Validation_Failed": "Es gibt ungültige oder fehlende Eingaben. Bitte prüfen Sie die markierten Felder",
  "Validation_Field_Required": "Dieses Feld ist erforderlich.",
  "Validation_OtoId_Contains_Invalid_Characters": "Die Oto-ID enthält unzulässige Zeichen",
  "Validation_Swiss_Mobile_Number":"Schweizer Mobilnummer erforderlich",
  "Validation_Referrer_Code_Not_Found": "Dieser Empfehlungscode wurde nicht gefunden.",
  "Validation_Referrer_Code_Not_Valid": "Dieser Empfehlungscode ist ungültig.",
  "Validation_Referrer_Product_Not_Found": "Für diesen Empfehlungscode wurde kein passendes Produkt gefunden.",
  "Validation_Voucher_Code_Not_Valid": "Dieser Gutscheincode ist ungültig.",
  "Validation_Phone_Or_Mobile_Required": "Telefon oder Mobile sind erforderlich.",

  "Variant_Not_Found":"Variante nicht gefunden oder nicht verfügbar",
  "Product_Not_Found":"Produkt nicht gefunden oder nicht verfügbar",
  "ZZZ_EndOfFile": ""
}